// import api from './fetchApi'
import chain from '@/lib/axios-chain'

// 个人信息
export const accountLogin = () => chain.create('/user/login/index', 'post')
export const accountRegister = () => chain.create('/user/reg/index', 'post')
export const accountRegister2 = () => chain.create('/user/reg/supply', 'post')
// 用户信息详情
export const accountProfile = () => chain.create('/user/user/userinfo')

// 解绑企业微信
export const unbindQw = () => chain.create('/user/user/unbindqw', 'post')

// 解绑工厂网
export const unbindGc = () => chain.create('/user/user/unbindgcw', 'post')
// 解绑微信
export const unbindWechat = () => chain.create('/user/user/unbindwx', 'post')
// 解绑钉钉
export const unbindDingding = () => chain.create('/user/user/unbinddt', 'post')

// 修改昵称
export const editTruename = () => chain.create('/user/user/settruename', 'post')

// 修改昵称
export const fetchLoginLog = () => chain.create('/user/loginlog/index', 'get')

// 获取订单列表
export const fetchorderDatas = () => chain.create('/config/getorder', 'get')

// 获取订单详情数据
export const fetchorderInfo = () => chain.create('/config/getorderdetail', 'get')

// 支付功能
export const orderPay = () => chain.create('/config/orderpay', 'post')

// 获取未开发票订单数据
export const fetchOrderListInvoice = () => chain.create('/config/getorder', 'get')
// 获取已开发票订单数据
export const fetchInvoiceList = () => chain.create('/user/invoice/index', 'get')

// 获取可开发票金额数据
export const fetchInvoiceMoney = () => chain.create('/config/getinmoney', 'get')
// 获取未开发票详情
export const fetchorderListInfo = () => chain.create('/config/getorderdetail', 'get')

// 获取发票详情信息
export const fetchInvoiceInfo = () => chain.create('/user/invoice/detail', 'get')

// 获取发票抬头信息列表数据
export const fetchInvoiceHistory = () => chain.create('/user/invoice/history', 'get')
// 获取发票抬头信息列表数据
export const fetchInvoiceApply = () => chain.create('/user/invoice/apply', 'post')
// 获取发票抬头信息列表数据
export const fetchProviceCityDatas = () => chain.create('/config/area/child', 'get')

export const pwdrepeat = () => chain.create('/user/user/modifypsw', 'post')
// 修改用户手机号
export const mobilerepeat = () => chain.create('/user/user/modifymobile', 'post')
// 修改用户邮箱
export const emailrepeat = () => chain.create('/user/user/modifyemail', 'post')
// 设置登录账户
export const bindSetUser = () => chain.create('/user/user/bindusername', 'post')
// 绑定手机
export const bindSetMobile = () => chain.create('/user/user/bindmobile', 'post')
// 设置登录账户
export const bindSetEmail = () => chain.create('/user/user/bindemail', 'post')
// 设置登录账户
export const mergeUser = () => chain.create('/user/user/bind', 'post')

// 获取企业微信和工厂网登录地址
export const getQwGcUrl = () => chain.create('/user/login/loginurl', 'get')

// 企业微信登录绑定
export const bindQw = () => chain.create('/user/wework/qwBind', 'post')

// 手机找回密码
export const telfindpwd = () => chain.create('/user/findpsw/find', 'post')

// 邮箱找回密码
export const findpwd = () => chain.create('/user/findpsw/find', 'post')
// 登录之后接口判断进入哪个页面
export const toOrgProject = () => chain.create('/user/organize/getOrganizeProject', 'get')
